import z from "zod";
import { mapErrorsToFields } from "../../../../utils";
import AllergyService from "../../../../services/AllergyService";

const api = new AllergyService();
export type State = {
  errors?: {
    name?: string[];    
    general?: string[];
  };
  message?: string | null;
  success?: boolean;
  defaultValues?: {
    name?: string;    
  };
};
const FormSchema = z.object({
  name: z.string().min(1, "Name is required."),  
  description: z.string().optional(),
  allergyCategoryId: z.number(),

});

export async function addAllergy(
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() ?? "",    
    description: formData.get("description")?.toString() ?? "",
    allergyCategoryId: parseInt(formData.get("allergyCategoryId")?.toString() ?? "0"),
  };
  
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);

    if (!validatedFields.success) {
      return {
        success: false,
        errors: mapErrorsToFields(validatedFields.error),
        message: "Missing Fields. Failed to Create Exercise Category.",
      };
    }
    const { name,description, allergyCategoryId} = validatedFields.data;

    const result = await api.createAllergy({ name,description, allergyCategoryId});
    if (result.status == 201)
      return {
        message: "Allergy created successfully.",
        success: true,
        defaultValues: defaultValues,
        errors: {},
      };
    else
      return {
        message: "Failed to create allergy .",
        success: false,
        errors: {},
        defaultValues: defaultValues,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to create allergy .",
      success: false,
      errors: {},
      defaultValues: defaultValues,
    };
  }
}
export async function updateAllergy(
    id: number,
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() ?? "",    
    description: formData.get("description")?.toString() ?? "",
    allergyCategoryId: parseInt(formData.get("allergyCategoryId")?.toString() ?? "0"),
  };  
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);

    if (!validatedFields.success) {
      return {
        success: false,
        errors: mapErrorsToFields(validatedFields.error),
        message: "Missing Fields. Failed to Update allergy Category.",
      };
    }
    const { name,description, allergyCategoryId } = validatedFields.data;

    const result = await api.updateAllergy(id,{ id, name,description, allergyCategoryId });
    if (result.status == 204)
      return {
        message: "Allergy updated successfully.",
        success: true,
        defaultValues: defaultValues,
        errors: {},
      };
    else
      return {
        message: "Failed to update allergy.",
        success: false,
        errors: {},
        defaultValues: defaultValues,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to update allergy.",
      success: false,
      errors: {},
      defaultValues: defaultValues,
    };
  }
}

export async function deleteAllergy(id: number, prevState: State) {
  try {
    await api.deleteAllergy(id);
    return {
      message: "Allergy deleted successfully.",
      success: true,
    };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to delete allergy.",
      success: false,
    };
  }
}
